<template>
  <LayoutStructure :menu="menu">
    <template #app-sidebar-header>
      <p class="mb-0 w-full text-center text-2xl font-bold">
        {{ $t('layouts.admin.app-sidebar.header.title') }}
      </p>
    </template>

    <template #app-sidebar-footer>
      <Button
        :label="$t('layouts.admin.app-sidebar.footer.return-app')"
        class="w-full"
        @click="navigateTo(getOrganizationRoutePath())"
      >
        <template #icon>
          <LucideIcon :icon="ArrowLeft" />
        </template>
      </Button>
    </template>

    <div class="h-screen w-full overflow-y-scroll">
      <slot />
    </div>
  </LayoutStructure>
</template>

<script lang="ts" setup>
import { ArrowLeft, Building2, Users } from 'lucide-vue-next'
import LucideIcon from '~/components/ui/LucideIcon.vue'
import LayoutStructure from '~/components/layouts/common/LayoutStructure.vue'
import { AppRoutes } from '~/constants/routes'

const { t } = useI18n()
const menu = [
  ...getFormattedAppConfigMenuItems('admin'),
  {
    label: t('layouts.admin.app-sidebar.menu.app-management.label'),
    items: [
      {
        label: t('layouts.admin.app-sidebar.menu.app-management.items.users'),
        icon: Users,
        to: AppRoutes.Admin.Users,
      },
      {
        label: t('layouts.admin.app-sidebar.menu.app-management.items.organizations'),
        icon: Building2,
        to: AppRoutes.Admin.Organizations,
      },
    ],
  },
]
</script>
